import {
  type LocalPreferenceAction,
  localPreferenceActions,
  type LocalPreferenceState
} from '../context';
import { patchChangesNothing } from './sameValue';

export const localPreferenceReducer = (
  state: LocalPreferenceState,
  action: LocalPreferenceAction
) => {
  let updatedState = state;
  switch (action.type) {
    case localPreferenceActions.initializePreference:
      if (patchChangesNothing(state, action.payload)) return state;
      updatedState = { ...state, ...action.payload };
      break;
    case localPreferenceActions.updatedLocalPreference: {
      const { updatedSettings } = action.payload;
      if (patchChangesNothing(state, updatedSettings)) return state;

      updatedState = {
        ...state,
        ...updatedSettings
      };
      break;
    }
    case localPreferenceActions.setMuteVideo:
      if (state.muteVideo === action.payload) return state;
      updatedState = { ...state, muteVideo: action.payload };
      break;
    case localPreferenceActions.SET_THEME:
      if (state.theme === action.payload) return state;
      updatedState = { ...state, theme: action.payload };
      break;
    default:
      return state;
  }
  return updatedState;
};
